import React, { useState, useRef } from 'react'
import { useStateValue } from '@State'

export const CertHeader = ({ disable }) => {
  const [state, dispatch] = useStateValue()
  const [editHeader, setEditHeader] = useState(false)
  const headerInput = useRef(null)

  const handleChange = () => {
    dispatch({
      type: 'UPDATE_CERT_INFO',
      payload: { header: headerInput.current.value },
    })
    setEditHeader(false)
  }

  if (editHeader) {
    return (
      <div className="text-center input_element" id="header">
        <input
          type="text"
          id="header_input"
          ref={headerInput}
          defaultValue={state.certInfo.header}
          onBlur={handleChange}
        />
      </div>
    )
  }

  return (
    <h2
      className={disable ? 'text-center' : 'text-center input_element'}
      id="header"
    >
      {state.certInfo.header}
      <div
        className={disable ? '' : 'icon icon_pencil'}
        id="header_pencil"
        onClick={() => setEditHeader(true)}
      />
    </h2>
  )
}
